// extracted by mini-css-extract-plugin
export var arrow = "DocumentRowItem-module--arrow--1ce34";
export var arrowNo = "DocumentRowItem-module--arrow_no--07e0f";
export var arrowYes = "DocumentRowItem-module--arrow_yes--022f0";
export var authors = "DocumentRowItem-module--authors--28a8e";
export var authorsContainer = "DocumentRowItem-module--authorsContainer--15c39";
export var backgroundImage = "DocumentRowItem-module--backgroundImage--8982a";
export var contentType = "DocumentRowItem-module--contentType--6f607";
export var ctaIcon = "DocumentRowItem-module--ctaIcon--24dfc";
export var ctaRow = "DocumentRowItem-module--ctaRow--ed63c";
export var documentRow = "DocumentRowItem-module--documentRow--9dfa8";
export var expandAuthors = "DocumentRowItem-module--expandAuthors--2f355";
export var flex = "DocumentRowItem-module--flex--858e5";
export var flex1 = "DocumentRowItem-module--flex_1--0d661";
export var flexCenter = "DocumentRowItem-module--flex_center--5ebfe";
export var flexCenterCol = "DocumentRowItem-module--flex_center_col--68d59";
export var flexCol = "DocumentRowItem-module--flex_col--ead0f";
export var flexFixCenterCol = "DocumentRowItem-module--flex_fix_center_col--1cfad";
export var flexFixedCenterCol = "DocumentRowItem-module--flex_fixed_center_col--9e317";
export var image = "DocumentRowItem-module--image--41d35";
export var imageContainer = "DocumentRowItem-module--imageContainer--513bc";
export var informationContainer = "DocumentRowItem-module--informationContainer--b8a48";
export var loadingContainer = "DocumentRowItem-module--loadingContainer--6fdbb";
export var loadingImageSkeleton = "DocumentRowItem-module--loadingImageSkeleton--b02f4";
export var overlay = "DocumentRowItem-module--overlay--0c99c";
export var publishingInformation = "DocumentRowItem-module--publishingInformation--91206";
export var publishingInformationLabel = "DocumentRowItem-module--publishingInformationLabel--a63dd";
export var rotating = "DocumentRowItem-module--rotating--1c037";
export var seeFullAbstract = "DocumentRowItem-module--seeFullAbstract--a38b7";
export var tags = "DocumentRowItem-module--tags--0b6e4";
export var title = "DocumentRowItem-module--title--a29ab";